import { render, staticRenderFns } from "./ServiceAreaLayer.vue?vue&type=template&id=e883bb82&scoped=true&"
import script from "./ServiceAreaLayer.vue?vue&type=script&lang=js&"
export * from "./ServiceAreaLayer.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreaLayer.vue?vue&type=style&index=0&id=e883bb82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e883bb82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e883bb82')) {
      api.createRecord('e883bb82', component.options)
    } else {
      api.reload('e883bb82', component.options)
    }
    module.hot.accept("./ServiceAreaLayer.vue?vue&type=template&id=e883bb82&scoped=true&", function () {
      api.rerender('e883bb82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ServiceAreaLayer.vue"
export default component.exports